<template>
    <div class="channelRights" ref="channelRights">
        <van-popover v-model="channelRights.show" trigger="click" :get-container="() => $refs.channelRights">
            <template #reference>
                <div class="head">
                    <div class="info">
                        <div class="icon"></div>
                        <div class="text">指定疗程诊疗费用全额抵扣</div>
                    </div>
                    <div class="operate">
                        <div class="link">
                            <span>查看权益</span>
                            <span class="arrow"></span>
                        </div>
                    </div>
                </div>
            </template>
            <div class="content">
                <div class="item">【{{ detail.channelName }}】权益患者</div>
                <div class="item">
                    <div class="label">可用权益：</div>
                    <div class="value">
                        <span>{{ detail.payRegCount }}次挂号免费</span>
                        <span>+</span>
                        <span>{{ detail.payAskCount }}次购药免费</span>
                    </div>
                </div>
                <div class="item">
                    <div class="label">权益使用权限：</div>
                    <div class="value">
                        <span>{{ formatTime(detail.validBeginDate).format('YYYY-MM-DD') }}</span>
                        <span>~</span>
                        <span>{{ formatTime(detail.validEndDate).format('YYYY-MM-DD') }}</span>
                    </div>
                </div>
            </div>
        </van-popover>
    </div>
</template>
<script>
import { formatTime } from '@/hooks/function'
export default {
    components: {

    },
    props: {
        detail: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            channelRights: {
                show: false
            }
        }
    },
    computed: {

    },
    mounted() {

    },
    destroyed() {

    },
    methods: {
        formatTime
    },
    watch: {

    }
}
</script>
<style lang="scss" scoped>
.channelRights {
    position: relative;
    font-size: 15px;

    :deep(.van-popover__wrapper),
    :deep(.van-popup) {
        width: 100%;
    }

    .head {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-radius: 4px;
        cursor: pointer;

        .info {
            flex: 1;
            display: flex;
            align-items: center;
            background: linear-gradient(90deg, #fce3c8, #fce3c8 50%, transparent 100%);
            max-width: 85%;
            padding: 5px;
            border-radius: 4px;

            .icon {
                width: 20px;
                height: 20px;
                background: url(@/assets/images/patient/vip.svg) center center / 100% 100% no-repeat;
            }

            .text {
                word-break: break-all;
                color: #f56c1f;
                margin-left: 3px;
            }
        }

        .operate {
            .link {
                display: flex;
                align-items: center;
                color: #3763fc;

                .arrow {
                    width: 0;
                    height: 0;
                    border: 6px solid transparent;
                    border-top-color: #3880ed;
                    border-bottom-width: 0;
                    margin-left: 5px;
                    transform: rotate(-90deg);
                    transition: .3s;

                    &.active {
                        transform: rotate(0);
                    }
                }
            }
        }
    }

    .content {
        width: 100%;
        padding: 10px;

        .item {
            display: flex;
            align-items: center;
            line-height: 2;
        }
    }
}
</style>